import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawChevronDownIcon from "./RawChevronDownIcon.svg.jsx";

const ChevronDownIcon = forwardRef(({ strokeWidth = "2px", ...props }, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawChevronDownIcon}
      strokeWidth={strokeWidth}
      {...props}
    />
  );
});

export default ChevronDownIcon;
